import EasyDataView from './EasyDataView/EasyDataView.vue'
import EasyDataList from './EasyDataList/EasyDataList.vue'
import EasyDataTable from './EasyDataTable/EasyDataTable.vue'
import EasyDataForm from './EasyDataForm/EasyDataForm.vue'

export const packages = {
  EasyDataView,
  EasyDataList,
  EasyDataForm,
  EasyDataTable,
}
